import Page from "./Page";
import SupervisorCalendar from "../ui/SupervisorCalendar";

const SupervisorCalendarPage = () => {
  return (
    <Page
      pageName="supervisorCalendar"
      includeToolbar={false}
    >
      <SupervisorCalendar />
    </Page>
  );
};

export default SupervisorCalendarPage;
